import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment} from "../../environments/environment";

const httpOptions = {
  headers: new HttpHeaders({'x-api-key':'apikey'})
};

interface login{
  status: any;
  data:{username:string,access_key:string,role:string,is_logged:number},
  errors:any
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  //private serverUrl='http://localhost/webapp/server/';
  private serverUrl=environment.serverUrl;
  constructor(private http:HttpClient) { }

  checkUserAuth(form):Observable<login>{
   /* return this.http.post<login>(this.serverUrl+'api/login',form.value,{observe:'response'}).pipe(
      tap(Response=>console.log(Response.status)),
      map(Response=>Response.body)
    );*/
    return this.http.post<login>(this.serverUrl+'checkLogin',form.value,{headers:new HttpHeaders({'x-api-key':'apikey'})}).pipe(
      catchError(this.handleErros)
    );
  }

  logoutUser(){
    return this.http.post<login>(this.serverUrl+'api/logout',null,{headers:new HttpHeaders({'x-api-key':'apikey'})}).pipe(
      catchError(this.handleErros)
    );

  }

  handleErros(error:HttpErrorResponse){
    return throwError(error);
  }
}
